<template>
  <div class="doctor-salary-rule-page">
    <el-form class="search-form" :model="searchForm" inline size="small">
      <el-form-item label="医生姓名">
        <el-input v-model="searchForm.condition.doctorName" clearable placeholder="请输入医生姓名" />
      </el-form-item>
      <el-form-item label="员工编号">
        <el-input v-model="searchForm.condition.userCode" clearable placeholder="请输入员工编号" />
      </el-form-item>
      <el-form-item label="工作室">
        <el-input v-model="searchForm.condition.teamName" clearable placeholder="请输入工作室名称" />
      </el-form-item>
      <el-form-item label="是否有保底工资">
        <el-select v-model="searchForm.condition.hasGuaranteeSalary" clearable placeholder="不限">
          <el-option label="不限" :value="null" />
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否有交通补贴">
        <el-select v-model="searchForm.condition.hasTrafficSubsidy" clearable placeholder="不限">
          <el-option label="不限" :value="null" />
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
      <el-form-item class="right-actions">
        <el-button type="primary" @click="handleExport">导出</el-button>
        <el-button @click="openImportDialog">导入</el-button>
        <el-button type="primary" @click="openAddDialog">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table class="rule-table" :data="tableData" border height="520" :cell-style="{ borderColor: '#dcdfe6' }"
      :header-cell-style="{ background: '#f5f7fa', borderColor: '#dcdfe6', color: '#333333' }">
      <el-table-column prop="doctorName" label="医生姓名" width="120" fixed="left" />
      <el-table-column prop="userCode" label="员工编号" width="120" fixed="left" />
      <el-table-column prop="teamName" label="所属工作室" width="120" fixed="left" />
      <el-table-column prop="hasGuaranteeSalary" label="是否有保底工资" width="120">
        <template slot-scope="scope">
          {{ scope.row.hasGuaranteeSalary === 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="guaranteeType" label="保底类型" width="140">
        <template slot-scope="scope">
          {{ scope.row.hasGuaranteeSalary === 1 ? (scope.row.guaranteeType === 1 ? '按月坐诊次数保底' : '按月保底') : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="guaranteeSalaryAmount" label="保底工资金额" width="120">
        <template slot-scope="scope">
          {{ scope.row.hasGuaranteeSalary === 1 ? scope.row.guaranteeSalaryAmount : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="guaranteeStartDate" label="保底开始时间" width="120" />
      <el-table-column prop="guaranteeEndDate" label="保底结束时间" width="120" />
      <el-table-column prop="registerFeeRate" label="挂号费发放比例" width="140" />
      <el-table-column prop="processFeeRate" label="加工费提成比例" width="140" />
      <el-table-column prop="clinicHerbRate" label="门诊饮片提成比例" width="140" />
      <el-table-column prop="clinicGranuleRate" label="门诊颗粒提成比例" width="140" />
      <el-table-column prop="onlineHerbRate" label="网诊饮片提成比例" width="140" />
      <el-table-column prop="onlineGranuleRate" label="网诊颗粒提成比例" width="140" />
      <el-table-column prop="physioCommissionMode" label="理疗开单提成方式" width="140">
        <template slot-scope="scope">
          {{ scope.row.physioCommissionMode === 1 ? '开单即提成' : '执行后提成' }}
        </template>
      </el-table-column>
      <el-table-column prop="physioOrderRate" label="开单提成比例" width="100" />
      <el-table-column prop="physioOrderStartDate" label="开单开始时间" width="100" />
      <el-table-column prop="physioSelfExecOrderRate" label="理疗执行本人开单提成比例" width="120" />
      <el-table-column prop="physioOtherExecOrderRate" label="理疗执行他人开单提成比例" width="120" />
      <el-table-column prop="trafficSubsidyAmount" label="是否有交通补贴" width="80">
        <template slot-scope="scope">
          {{ scope.row.hasTrafficSubsidy === 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="trafficSubsidyAmount" label="交通补贴单次金额" width="80">
        <template slot-scope="scope">
          {{ scope.row.hasTrafficSubsidy === 1 ? scope.row.trafficSubsidyAmount : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="certificateSubsidyAmount" label="证书补贴" width="80" />
      <el-table-column prop="certificateSubsidyDeptName" label="证书补贴所属馆" width="80" />
      <el-table-column prop="otherFixedSubsidyAmount" label="其它固定补贴" width="120" />
      <el-table-column prop="otherFixedSubsidyDeptName" label="其它固定补贴所属馆" width="120" />
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" @click="openEditDialog(scope.row)">编辑</el-button>
          <el-button type="danger" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-wrap">
      <el-pagination background layout="sizes,total, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]"
        :page-size="searchForm.pageSize" :current-page="searchForm.pageIndex" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog title="导入医生薪酬规则" :visible.sync="importDialogVisible" width="420px">
      <div class="import-content">
        <el-button type="text" @click="handleTemplateDownload">下载导入模板</el-button>
        <el-upload class="upload-box" action="" accept=".xls,.xlsx" :auto-upload="false" :limit="1"
          :file-list="fileList" :on-change="handleFileChange" :on-remove="handleFileRemove">
          <el-button size="small">选择文件</el-button>
          <span slot="tip" class="upload-tip">仅支持 xls、xlsx 文件</span>
        </el-upload>
      </div>
      <span slot="footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleImport">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="dialogTitle" :visible.sync="ruleDialogVisible" width="800px" top="5vh">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="160px" size="small">
        <div class="form-section-title">基本信息</div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="医生姓名" prop="doctorId">
              <el-select v-model="ruleForm.doctorId" placeholder="请选择医生姓名" filterable remote
                :remote-method="getDoctorList" clearable @change="doctorChange">
                <el-option v-for="item in doctorList" :key="item.doctorId" :label="item.nickName"
                  :value="item.doctorId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="员工编号" prop="userCode">
              <el-input v-model="ruleForm.userCode" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属工作室">
              <el-input v-model="ruleForm.teamName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否有保底工资" prop="hasGuaranteeSalary">
              <el-radio-group v-model="ruleForm.hasGuaranteeSalary">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.hasGuaranteeSalary === 1" :span="24">
            <el-form-item label="保底类型" prop="guaranteeType">
              <el-radio-group v-model="ruleForm.guaranteeType" @input="ruleForm.guaranteeSalaryAmount = ''">
                <el-radio :label="1">按月坐诊次数保底</el-radio>
                <el-radio :label="0">按月保底</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.hasGuaranteeSalary === 1" :span="12">
            <el-form-item label="保底工资金额" prop="guaranteeSalaryAmount"
              :rules="[{ validator: validatePositiveInteger, trigger: 'blur' }]">
              <el-input v-model="ruleForm.guaranteeSalaryAmount" placeholder="请输入金额" />
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.hasGuaranteeSalary === 1" :span="24">
            <div class="flex items-center">
              <el-form-item label="保底时间" prop="guaranteeStartDate"
                :rules="[{ validator: validateStartDate, trigger: 'blur' }]">
                <el-date-picker class="w200 mr16" v-model="ruleForm.guaranteeStartDate" type="date"
                  value-format="yyyy-MM-dd" placeholder="开始日期" />
              </el-form-item>
              <div style="line-height: 36px;">至</div>
              <el-form-item prop="guaranteeEndDate" class="guaranteeEndDate"
                :rules="[{ validator: validateEndDate, trigger: 'blur' }]">
                <el-date-picker class="w200 ml16" v-model="ruleForm.guaranteeEndDate" type="date"
                  value-format="yyyy-MM-dd" placeholder="结束日期" />
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <div class="form-section-title">挂号/销售提成</div>
        <el-row :gutter="16">
          <el-col v-for="item in ratioFields" :key="item.prop" :span="12">
            <el-form-item :label="item.label" :prop="item.prop"
              :rules="[{ validator: validateRatio, trigger: 'blur' }]">
              <el-input v-model="ruleForm[item.prop]" placeholder="请输入0-100">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-section-title">理疗提成</div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="理疗开单提成方式">
              <el-radio-group v-model="ruleForm.physioCommissionMode">
                <el-radio :label="0">执行后提成</el-radio>
                <el-radio :label="1">开单即提成</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.physioCommissionMode === 0" :span="24">
            <el-form-item label="开单开始时间" prop="physioOrderStartDate">
              <el-date-picker v-model="ruleForm.physioOrderStartDate" type="date" value-format="yyyy-MM-dd"
                placeholder="开始日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开单提成比例" prop="physioOrderRate"
              :rules="[{ validator: validateRatio, trigger: 'blur' }]">
              <el-input v-model="ruleForm.physioOrderRate" placeholder="请输入0-100">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行本人开单提成比例" prop="physioSelfExecOrderRate"
              :rules="[{ validator: validateRatio, trigger: 'blur' }]">
              <el-input v-model="ruleForm.physioSelfExecOrderRate" placeholder="请输入0-100">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行他人开单提成比例" prop="physioOtherExecOrderRate"
              :rules="[{ validator: validateRatio, trigger: 'blur' }]">
              <el-input v-model="ruleForm.physioOtherExecOrderRate" placeholder="请输入0-100">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-section-title">其它</div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="是否有交通补贴" prop="hasTrafficSubsidy">
              <el-radio-group v-model="ruleForm.hasTrafficSubsidy">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.hasTrafficSubsidy === 1" :span="12">
            <el-form-item label="交通补贴单次金额" prop="trafficSubsidyAmount"
              :rules="[{ validator: validatePositiveInteger, trigger: 'blur' }]">
              <el-input v-model="ruleForm.trafficSubsidyAmount" placeholder="请输入金额" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="证书补贴金额" prop="certificateSubsidyAmount"
              :rules="[{ validator: validatePositiveInteger, trigger: 'blur' }]">
              <el-input v-model="ruleForm.certificateSubsidyAmount" placeholder="请输入金额" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书补贴所属馆">
              <el-select v-model="ruleForm.certificateSubsidyDeptId" filterable placeholder="请选择">
                <el-option :label="item.deptName" v-for="item in deptList" :key="item.deptId" :value="item.deptId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="其它固定补贴金额" prop="otherFixedSubsidyAmount"
              :rules="[{ validator: validatePositiveInteger, trigger: 'blur' }]">
              <el-input v-model="ruleForm.otherFixedSubsidyAmount" placeholder="请输入金额" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="其它固定补贴所属馆">
              <el-select v-model="ruleForm.otherFixedSubsidyDeptId" filterable placeholder="请选择">
                <el-option :label="item.deptName" v-for="item in deptList" :key="item.deptId" :value="item.deptId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="ruleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { doctorRulePage, doctorRuleSave, getDoctorRule, doctorRuleUpdate, deleteDoctorRuleById, getDoctorRuleImportTemplate, importDoctorRule, doctorRuleExport } from '@/api/salary';
import { doctorTeamOptionsList } from '@/api/studio';
import { getDoctorList } from '@/api/operation';
import { debounce, deepClone } from '@/utils/validateBase'
import { getActiveDeptList } from '@/api/dept'
const getEmptyRuleForm = () => ({
  doctorId: '',
  doctorName: '',
  userCode: '',
  teamId: '',
  teamName: '',
  hasGuaranteeSalary: 0,
  guaranteeType: '',
  guaranteeSalaryAmount: '',
  guaranteeStartDate: '',
  guaranteeEndDate: '',
  registerFeeRate: '',
  processFeeRate: '',
  clinicHerbRate: '',
  clinicGranuleRate: '',
  onlineHerbRate: '',
  onlineGranuleRate: '',
  physioCommissionMode: 0,
  physioOrderStartDate: '',
  physioOrderRate: '',
  physioSelfExecOrderRate: '',
  physioOtherExecOrderRate: '',
  hasTrafficSubsidy: 0,
  trafficSubsidyAmount: '',
  certificateSubsidyAmount: '',
  certificateSubsidyDeptId: '',
  otherFixedSubsidyAmount: '',
  otherFixedSubsidyDeptId: ''
});

export default {
  name: 'DoctorSalaryRule',
  data() {
    return {
      total: 0,
      editIndex: -1,
      fileList: [],
      importDialogVisible: false,
      ruleDialogVisible: false,
      searchForm: {
        pageIndex: 1,
        pageSize: 10,
        condition: {
          doctorId: '',
          doctorName: '',
          teamName: '',
          userCode: '',
          hasGuaranteeSalary: null, //是否有保底工资：0-否，1-是。
          hasTrafficSubsidy: null //是否有交通补贴：0-否，1-是。
        }
      },
      ruleForm: getEmptyRuleForm(),
      rules: {
        doctorId: [{ required: true, message: '请输入医生姓名', trigger: 'blur' }],
        userCode: [{ required: true, message: '请输入员工编号', trigger: 'blur' }],
        hasGuaranteeSalary: [{ required: true, message: '请选择是否有保底工资', trigger: 'change' }],
        guaranteeType: [{ required: true, message: '请选择保底类型', trigger: 'change' }],
        guaranteeSalaryAmount: [{ required: true, message: '请输入保底工资金额', trigger: 'blur' }],
        hasTrafficSubsidy: [{ required: true, message: '请选择是否有交通补贴', trigger: 'change' }],
      },
      ratioFields: [
        { prop: 'registerFeeRate', label: '挂号费发放比例' },
        { prop: 'processFeeRate', label: '加工费提成比例' },
        { prop: 'clinicHerbRate', label: '门诊饮片提成比例' },
        { prop: 'clinicGranuleRate', label: '门诊颗粒提成比例' },
        { prop: 'onlineHerbRate', label: '网诊饮片提成比例' },
        { prop: 'onlineGranuleRate', label: '网诊颗粒提成比例' }
      ],
      tableData: [],
      doctorList: [],
      deptList: []
    };
  },
  computed: {
    dialogTitle() {
      return this.editIndex > -1 ? '编辑医生薪酬规则' : '新增医生薪酬规则';
    }
  },
  mounted() {
    this.getRuleList();
    this.getActiveDeptList();
  },
  methods: {
    validateStartDate(rule, value, callback) {
      // 开始日期不能大于结束日期
      if (value && this.ruleForm.guaranteeEndDate && new Date(value) > new Date(this.ruleForm.guaranteeEndDate)) {
        callback(new Error('开始日期不能大于结束日期'));
      } else {
        callback();
      }
    },
    validateEndDate(rule, value, callback) {
      // 结束日期不能小于开始日期
      if (value && this.ruleForm.guaranteeStartDate && new Date(value) < new Date(this.ruleForm.guaranteeStartDate)) {
        callback(new Error('结束日期不能小于开始日期'));
      } else {
        callback();
      }
    },
    //0-100的整数
    validateRatio(rule, value, callback) {
      if (value && !/^[0-9]\d*$/.test(value)) {
        callback(new Error('请输入0-100的整数'));
      } else {
        callback();
      }
    },
    //正整数
    validatePositiveInteger(rule, value, callback) {
      if (value && !/^[1-9]\d*$/.test(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    getDoctorList: debounce(async function (val) {
      const { code, data } = await getDoctorList({ searchKey: val });
      if (code === 200) {
        this.doctorList = data || [];
      }
    }, 300),
    doctorChange(val) {
      this.ruleForm.doctorId = val;
      this.ruleForm.doctorName = this.doctorList.find(item => item.doctorId === val).nickName;
      this.ruleForm.userCode = this.doctorList.find(item => item.doctorId === val).userCode;
      this.getTeamOptionsList(val);
    },
    async getTeamOptionsList(doctorId) {
      const { code, data } = await doctorTeamOptionsList({ doctorId });
      if (code === 200 && data && data.length > 0) {
        this.ruleForm.teamId = data[0].teamId;
        this.ruleForm.teamName = data[0].teamName;
      } else {
        this.ruleForm.teamId = '';
        this.ruleForm.teamName = '';
      }
    },

    handleSearch() {
      this.searchForm.pageIndex = 1;
      this.getRuleList();
    },
    handleReset() {
      this.searchForm = {
        pageIndex: 1,
        pageSize: 10,
        condition: {
          doctorId: '',
          doctorName: '',
          teamName: '',
          userCode: '',
          hasGuaranteeSalary: null, //是否有保底工资：0-否，1-是。
          hasTrafficSubsidy: null //是否有交通补贴：0-否，1-是。
        }
      };
      this.getRuleList();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.searchForm.pageIndex = 1;
      this.getRuleList();
    },
    handleCurrentChange(pageIndex) {
      this.searchForm.pageIndex = pageIndex;
      this.getRuleList();
    },
    openImportDialog() {
      this.fileList = [];
      this.importDialogVisible = true;
    },
    handleTemplateDownload() {
      getDoctorRuleImportTemplate({ name: '医生薪酬规则导入模板' }).then(res => {
        if (res.code === 200) {
          this.$message.success('下载导入模板成功');
        }
      })
    },
    handleFileChange(file, fileList) {
      if (!file) return;
      this.fileList = fileList.slice(-1);
      console.log(this.fileList, 11111);
    },
    handleFileRemove(file, fileList) {
      if (!file) return;
      this.fileList = fileList;
    },
    handleImport() {
      if (!this.fileList.length) {
        this.$message.warning('请选择导入文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      importDoctorRule(formData).then(res => {
        if (res.code === 200) {
          this.$message.success('导入成功');
          this.importDialogVisible = false;
        }
      })
    },
    openAddDialog() {
      this.editIndex = -1;
      this.ruleForm = getEmptyRuleForm();
      this.ruleDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
      });
    },
    openEditDialog(row) {
      this.editIndex = this.tableData.indexOf(row);
      getDoctorRule({ id: row.id }).then(res => {
        if (res.code === 200) {
          this.ruleForm = {
            ...getEmptyRuleForm(),
            ...res.data,
          };
          this.doctorList.push({
            doctorId: res.data.doctorId,
            nickName: res.data.doctorName,
          });
        }
      })
      this.ruleDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
      });
    },
    handleSave() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return;
        let params = deepClone(this.ruleForm);
        if (params.hasGuaranteeSalary == 0) {
          params.guaranteeStartDate = '';
          params.guaranteeEndDate = '';
          params.guaranteeType = '';
          params.guaranteeSalary = '';
        }
        if (params.physioCommissionMode == 1) {
          params.physioOrderStartDate = ''
        }
        if (this.editIndex == -1) {
          doctorRuleSave(params).then(res => {
            if (res.code === 200) {
              this.getRuleList();
              this.ruleDialogVisible = false;
              this.$message.success('保存成功');
            }
          })
        } else {
          doctorRuleUpdate(params).then(res => {
            if (res.code === 200) {
              this.getRuleList();
              this.ruleDialogVisible = false;
              this.$message.success('保存成功');
            }
          })
        }
      });
    },
    handleDelete(row) {
      this.$confirm('确认删除该医生薪酬规则？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDoctorRuleById(row.id).then(res => {
          if (res.code === 200) {
            this.getRuleList();
            this.$message.success('删除成功');
          }
        })
      }).catch(() => { });
    },
    getGuaranteeTypeText(value) {
      const map = {
        month: '按月保底',
        naturalMonth: '按自然月保底'
      };
      return map[value] || '';
    },
    addPercent(value) {
      return value || value === 0 ? `${value}%` : '';
    },
    async getRuleList() {
      let { code, data } = await doctorRulePage(this.searchForm)
      if (code === 200) {
        this.tableData = data.records || [];
        this.total = data.total || 0;
      }
    },
    async getActiveDeptList() {
      let { code, data } = await getActiveDeptList()
      if (code === 200) {
        this.deptList = data || [];
      }
    },
    handleExport() {
      doctorRuleExport(this.searchForm,{ name: '医生薪酬规则列表' }).then(res => {
        if (res.code === 200) {
          this.$message.success('导出成功');
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.doctor-salary-rule-page {
  height: 100%;
  padding: 16px;
  background: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .search-form {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 12px;

    /deep/ .el-form-item {
      margin-bottom: 12px;
    }

    .right-actions {
      margin-left: auto;
    }
  }

  .rule-table {
    width: 100%;
  }

  .page-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  .import-content {
    .upload-box {
      margin-top: 12px;
    }

    .upload-tip {
      margin-left: 10px;
      color: #909399;
      font-size: 12px;
    }
  }

  .form-section-title {
    position: relative;
    margin: 8px 0 14px;
    padding-left: 10px;
    font-weight: 600;
    color: #333333;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      width: 4px;
      height: 14px;
      background: #0b67c8;
      border-radius: 2px;
    }
  }

  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }

  .guaranteeEndDate {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>